import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  Signal,
  ViewChild,
} from '@angular/core';
import { RebrandService } from 'src/app/core/services/rebrand.service';
import { TIconColor } from 'src/app/project/components/icon/icon-colors.model';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

@Component({
  selector: 'pp-side-panel-menu-button',
  templateUrl: './side-panel-menu-button.component.html',
  styleUrl: './side-panel-menu-button.component.scss',
  standalone: false,
})
export class SidePanelMenuButtonComponent {
  @ViewChild('menuButton') menuButton: ElementRef<HTMLButtonElement>;
  @Input() ppIconSrc: EIconPath;
  @Input() ppText: string;
  @Input() ppDataTarget: string;
  @Input() ppDisabled: boolean;
  @Input() ppDataTest: string;
  @Input() ppActive: boolean;
  @Input() ppShowIndicator: boolean;
  @Input() ppTogglesPanel: boolean = false;

  @Output() ppAction = new EventEmitter<void>();

  EIconPath = EIconPath;
  readonly rebrandEnabled: Signal<boolean> = inject(RebrandService).rebrandEnabled;

  get iconColor(): TIconColor {
    return this.rebrandEnabled() ? 'inherit' : 'white';
  }

  ngAfterViewInit(): void {
    this.menuButton.nativeElement.setAttribute('data-m-target', this.ppDataTarget);
    this.menuButton.nativeElement.setAttribute('data-test', this.ppDataTest);
  }

  action(): void {
    if (this.ppDisabled) {
      return;
    }

    this.ppAction.emit();
  }
}
